import { IconButton, Stack, Typography } from "@mui/material";
import { Delete, UploadFile } from "@mui/icons-material";
import { colours } from "../../../../StyleConstants";

interface Props {
    removeFile: () => void;
    participantCount: number;
    errors: string[];
    warnings: string[];
}

const File = (props: Props) => {

    const getColour = () => {
        if (props.errors.length > 0) {
            return colours.error.error;
        } else if (props.warnings.length > 0) {
            return colours.warning.warn;
        } else {
            return colours.success.success;
        }
    }

    const getTitle = () => {
        if (props.errors.length > 0) {
            return 'Upload failed. Filter not applied.'
        } else if (props.warnings.length > 0) {
            return 'File parsed with the following warnings:';
        } else {
            return "Successfully parsed file";
        }
    }

    const showIssues = () => {
        return (props.errors.length > 0 || props.warnings.length > 0);
    }

    return (
        <Stack
            direction="row"
            alignItems="center"
            sx={{ gap: '16px', width: '90%' }}
        >
            <UploadFile sx={{ color: getColour() }} />
            <Stack
                direction="column"
                gap={1}
                sx={{ flexGrow: 2 }}
            >
                <Typography fontSize="16px" fontWeight={500} sx={{ color: getColour() }}>
                    {getTitle()}
                </Typography>
                {showIssues() && (
                    <ul>
                        {props.errors.map((error: string, i: number) => (
                            <li key={`error-${i}`}>
                                <Typography fontSize="14px" fontWeight={400} sx={{ color: colours.error.error }}>
                                    {error}
                                </Typography>
                            </li>
                        ))}
                        {props.warnings.map((warning: string, i: number) => (
                            <li key={`warning-${i}`}>
                                <Typography fontSize="14px" fontWeight={400} sx={{ color: colours.warning.warn }}>
                                    {warning}
                                </Typography>
                            </li>
                        ))}
                    </ul>
                )}
            </Stack>
            <IconButton onClick={props.removeFile}>
                <Delete />
            </IconButton>
        </Stack>
    )
}

export default File;